import React from 'react';
import classNames from 'classnames';

import styles from '../MobileCard.module.scss';

import { MobileCardData, MobileField, MobileFieldsOfLane, MobileFieldTypes } from '../../types';
import { Title } from './Title';

export function Field<D extends MobileCardData>(field: MobileField<D>, dataItem: D): React.ReactElement<any> {
    return (
        <div
            className={classNames([
                styles.field,
                field.isPrimary && styles.fieldPrimary,
                field.fieldsOnLane === MobileFieldsOfLane.SingleField && styles.singleOnLane,
                field.fieldsOnLane === MobileFieldsOfLane.PairField && styles.pairOnLane,
            ])}
        >
            {!field.withoutTitle && Title(field, dataItem)}
            <div
                id={dataItem.id}
                className={classNames([
                    styles.textValue,
                    field.isPrimary && styles.textValuePrimary,
                    field.fieldType === MobileFieldTypes.Phone && styles.textPhone,
                ])}
            >
                {(dataItem[field.accessor] as React.ReactNode) ?? dataItem.visitTime}
            </div>
        </div>
    );
}
